import image01 from '../images/content-master/01.jpeg';
import imageWebp01 from '../images/content-master/01.webp';

import image02 from '../images/content-master/02.jpg';
import imageWebp02 from '../images/content-master/02.webp';

import image03 from '../images/content-master/03.jpg';
import imageWebp03 from '../images/content-master/03.webp';

import image04 from '../images/content-master/04.jpeg';
import imageWebp04 from '../images/content-master/04.webp';

import image05 from '../images/content-master/05.png';
import imageWebp05 from '../images/content-master/05.webp';

const contentMaster = [
	{
		id: '01',
		title: 'Rig para Animación',
		image: image01,
		imageWebp: imageWebp01,
		description:
			'Crearemos desde cero el Rig facial y corporal de Sara y lo dejaremos listo para animación.',
		url: 'https://www.youtube.com/watch?v=5zvlXxoaNv4',
	},
	{
		id: '02',
		title: 'Rig de Soldado para Videojuegos',
		image: image02,
		imageWebp: imageWebp02,
		description:
			'Vive una gran experiencia en la realización desde cero avanzado en Rigging en maya.',
		url: 'https://www.youtube.com/watch?v=5zvlXxoaNv4',
	},
	{
		id: '03',
		title: 'Rig Inorgánico',
		image: image03,
		imageWebp: imageWebp03,
		description: 'Crearemos paso a paso todo el Rig de este increíble toro.',
		url: 'https://www.youtube.com/watch?v=45ioGu0QBoo',
	},
	{
		id: '04',
		title: 'Ejercicios de Aprendizaje',
		image: image04,
		imageWebp: imageWebp04,
		description:
			'Si estas en cero no te preocupes, aprenderás lo necesario para tener buenas para crear tus propios Rig.',
		url: 'https://www.youtube.com/watch?v=gQHdfVqAnrw',
	},
	{
		id: '05',
		title: 'Rig y Animación Básica',
		image: image05,
		imageWebp: imageWebp05,
		description: 'Crea Rig y animación de este grandioso personaje y lo mejor paso a paso.',
		url: 'https://www.youtube.com/watch?v=3E2ul4jfTPo',
	},
];

export default contentMaster;
